import React from 'react';
import TableRow from 'material-ui/Table/TableRow';
import TableCell from 'material-ui/Table/TableCell';
import CancelButton from './CancelButton';
import HostSigningButton from './HostSigningButton';
import ParticipantName from './ParticipantName';
import ParticipantEmailWrapper from './ParticipantEmailWrapper';
import Moment from 'react-moment';
import 'moment-timezone';
import m from 'moment';

function DocumentRow(props) {
  const timeZone = props.user.timeZone;
  const guess = m.tz.guess();
  return props.documents.map(document => {
    return (
      <TableRow key={document.id}>
        <TableCell>
          <ParticipantName participant={document.nextParticipant} />
        </TableCell>
        <TableCell>
          <ParticipantEmailWrapper
            document={document}
            participant={document.nextParticipant}
            updateDocuments={props.updateDocuments}
          />
        </TableCell>
        <TableCell>{document.name}</TableCell>
        <TableCell>
          <Moment tz={timeZone ? timeZone : guess} interval={0} format="M/D/YY">
            {document.created}
          </Moment>
        </TableCell>
        <TableCell numeric>
          <HostSigningButton
            participant={document.nextParticipant}
            document={document}
          />
          <CancelButton
            document={document}
            updateDocuments={props.updateDocuments}
          />
        </TableCell>
      </TableRow>
    );
  });
}

export default DocumentRow;



// WEBPACK FOOTER //
// ./src/components/DocumentRow.js